import React, { useState, useEffect } from 'react';
import haukeApiService from '../../services/haukeApi';
import { showSuccessToast } from '../../utils/toastUtils';
import '../../assets/css/profil-admin.css';
import '../../assets/css/mantis-toasts.css';

const Dienste = ({ hofId }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [saving, setSaving] = useState(false);
  const [hasChanges, setHasChanges] = useState(false);

  // Features nach Rubriken organisiert
  const featureCategories = [
    {
      title: 'Verkauf & Service',
      icon: '🛒',
      features: [
        { id: 'hofladen', label: 'Hofladen' },
        { id: 'lieferservice', label: 'Lieferservice' },
        { id: 'versand', label: 'Versand' },
        { id: 'selbstbedienung', label: 'Selbstbedienung' },
        { id: 'automat', label: 'SB-Automat' },
        { id: '24_7', label: '24/7 geöffnet' },
        { id: 'abokiste', label: 'Abokiste' },
        { id: 'online_shop', label: 'Online Shop' },
        { id: 'milchtankstelle', label: 'Milchtankstelle' },
        { id: 'selfpick', label: 'Selber Pflücken' }
      ]
    },
    {
      title: 'Märkte & Events',
      icon: '🎪',
      features: [
        { id: 'wochenmarkt', label: 'Wochenmarkt' },
        { id: 'bauernmarkt', label: 'Bauernmarkt' },
        { id: 'hofführung', label: 'Hofführung' },
        { id: 'erlebnisbauernhof', label: 'Erlebnisbauernhof' }
      ]
    },
    {
      title: 'Gastronomie',
      icon: '☕',
      features: [
        { id: 'hofcafe', label: 'Hofcafé' },
        { id: 'hofgastronomie', label: 'Hofgastronomie' }
      ]
    },
    {
      title: 'Ausstattung & Zugänglichkeit',
      icon: '♿',
      features: [
        { id: 'parken', label: 'Parkplätze vorhanden' },
        { id: 'barrierefrei', label: 'Barrierefrei' },
        { id: 'kinder_willkommen', label: 'Kinder willkommen' },
        { id: 'hunde_erlaubt', label: 'Hunde erlaubt' }
      ]
    },
    {
      title: 'Bezahlung',
      icon: '💳',
      features: [
        { id: 'payment_card', label: 'Kartenzahlung' },
        { id: 'payment_cash', label: 'Barzahlung' }
      ]
    }
  ];

  // Flache Liste aller Features für Berechnungen
  const allFeatures = featureCategories.flatMap(cat => cat.features);

  useEffect(() => {
    loadData();
  }, [hofId]);

  const loadData = async () => {
    try {
      setLoading(true);
      const response = await haukeApiService.getDirekterzeugerDetails(hofId);
      setData(response.data);
    } catch (err) {
      console.error('Error loading data:', err);
      setError('Fehler beim Laden der Daten');
    } finally {
      setLoading(false);
    }
  };



  const handleFeatureToggle = (featureId) => {
    const currentFeatures = data.features || [];
    const newFeatures = currentFeatures.includes(featureId)
      ? currentFeatures.filter(f => f !== featureId)
      : [...currentFeatures, featureId];
    
    setData({ ...data, features: newFeatures });
    setHasChanges(true);
  };

  const handleSave = async () => {
    if (!hasChanges) return;

    try {
      setSaving(true);
      const updateData = {
        features: data.features || []
      };
      
      await haukeApiService.updateDirekterzeuger(hofId, updateData);
      setHasChanges(false);
      showSuccessToast('Dienste erfolgreich gespeichert!');
    } catch (err) {
      console.error('Error saving:', err);
      alert('Fehler beim Speichern: ' + err.message);
    } finally {
      setSaving(false);
    }
  };

  const handleCancel = () => {
    if (hasChanges) {
      if (window.confirm('Änderungen verwerfen?')) {
        loadData();
        setHasChanges(false);
      }
    }
  };

  if (loading) return <div className="webling-loading">Daten werden geladen...</div>;
  if (error) return <div className="webling-error">{error}</div>;
  if (!data) return <div className="webling-error">Keine Daten verfügbar</div>;

  const selectedFeatures = data.features || [];

  return (
    <div className="webling-container">
      <div className="webling-content">
        {featureCategories.map(category => (
          <div key={category.title} className="form-section">
            <h3>
              <span className="category-icon">{category.icon}</span>
              {category.title}
            </h3>
            <div className="features-grid">
              {category.features.map(feature => (
                <label key={feature.id} className="feature-checkbox">
                  <input
                    type="checkbox"
                    checked={selectedFeatures.includes(feature.id)}
                    onChange={() => handleFeatureToggle(feature.id)}
                    disabled={saving}
                  />
                  <span className="checkbox-label">{feature.label}</span>
                </label>
              ))}
            </div>
          </div>
        ))}


      </div>

      <div className="webling-footer">
        <button 
          onClick={handleSave}
          disabled={!hasChanges || saving}
          className="save-button"
        >
          {saving ? 'Speichern...' : 'Speichern'}
        </button>
        <button 
          onClick={handleCancel}
          disabled={saving}
          className="cancel-button"
        >
          Schließen
        </button>
      </div>
    </div>
  );
};

export default Dienste; 